import { toast } from "react-toastify";

export const ShowToastError = (props) => {
  if (!props || !props.error) {
    toast.error("Something went wrong. Please try again later.");
    return null;
  }

  const { error } = props;

  let content = "Something went wrong. Please try again later.";
  if (error?.response?.data?.detail) {
    const detail = error.response.data.detail;
    if (typeof detail === "string") {
      content = detail;
    } else if (detail.masked_error) {
      content = `#${detail.error_code || ""} ${detail.masked_error}`;
    }
  }

  toast.error(content);
  return null;
};
